import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionAction',
  props: {
    icon: null,
    title: null,
    description: null,
    buttonText: null,
    disabled: { type: Boolean },
    buttonColor: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: "click"): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, Icon }
}

})